<template>
  <div style="text-align: center;">
    <PaymentForm 
      v-if="!payment"
      :paymentProductName="paymentDescription()" 
      :paymentProductValue="paymentValue()"
      :paymentProductOwnerIdentification="user.cnpj"
      @doPayment="processPayment" 
    />
    
    <OrderPaymentInfoSuccess v-if="payment" :payment="payment" />
    
    <v-btn depressed color="secondary" @click.prevent="goToOrders()" class="mt-5">
      Acessar Pedidos
    </v-btn>
  </div> 
</template>

<script>
import PaymentService from '@/services/pagamento.service';
import PaymentForm from '@/components/Payment/PaymentForm.vue';
import { mapState } from "vuex";
import OrderPaymentInfoSuccess from './OrderPaymentInfoSuccess.vue';

export default {
  name: "GroupPaymentForm",
  
  components: {
    PaymentForm,
    OrderPaymentInfoSuccess
  },
  
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  
  data: () => ({
    payments: [],

    payment: null
  }),

  mounted() {    
    this.fetchPayments(this.group.id);
  },
  
  computed: {
    ...mapState("global", ["user"]),
  },
  
  methods: {
    fetchPayments(group_id) {
      if (!group_id) return;

      PaymentService
        .list({input: { group_id: group_id }})
        .subscribe({
          next: ({items}) => {            
            this.payments = items;
          }
      });
    },

    paymentDescription() {
      return `${this.payments[0].description}` || 'Pagamento do grupo';
    },

    paymentValue() {
      return parseFloat(this.payments[0].value.raw);
    },  

    goToOrders() {
      this.$router.push({ name: 'orders-list', query: { group: this.group.id} });
    },

    processPayment(event) {          
      PaymentService
        .process(this.payments[0].id, event)
        .subscribe({
          next: ({id}) => {            
            this.$emit('doPayment', {...event, id});
            this.fetchPayment(id)
          }
        });
    },

    fetchPayment(payment_id) { 
      if (!payment_id) return;     
      
      PaymentService
        .show(payment_id)
        .subscribe({
          next: (data) => {            
            this.payment = data;                        
          }
      });    
    }
  }
};
</script>